<template>
	<div
		class="bg-white shadow overflow-hidden pl-3 pr-3 sm:pr-3 pt-2 pb-3 rounded-lg sm:rounded-xl cursor-pointer"
		:class="[
			isActive ? 'ring-2' : '',
			offer.trade == 'SELL' ? 'ring-green-500' : 'ring-orange-500',
		]"
	>
		<!-- <div v-if="offer.trade == 'SELL'" class="text-green-500 text-xs">{{__('Sell Offer') }}</div>
        <div v-else class="text-orange-500 text-xs">{{__('Buy Offer') }}</div> -->

		<div class="flex gap-x-2 flex-shrink-0 pt-0.5 mb-1">
			<div
				v-if="offer.trade == 'SELL'"
				class="bg-green-500 rounded-full w-4 h-4"
			></div>
			<div v-else class="bg-orange-500 w-4 h-4"></div>
			<div
				class="font-medium text-xs whitespace-nowrap"
				:class="offer.trade == 'SELL' ? 'text-green-500' : 'text-orange-500'"
			>
				{{ offer.trade == "BUY" ? __("Buy Offer") : __("Sell Offer") }}
			</div>
			<crop-timeago
				class="ml-auto text-xs text-gray-500 truncate"
				v-bind:date="offer.updated_at"
			/>
		</div>

		<div class="relative flex gap-x-2">
			<div class="flex-grow min-w-0">
				<div class="flex items-baseline justify-between mb-2 w-full space-x-2">
					<h3
						class="font-medium text-gray-900 flex-shrink flex items-baseline min-w-0 space-x-1"
					>
						<span class="whitespace-nowrap">
							{{
								$cropOptions.getLocalizedLabel(
									offer.product__grade,
									$cropOptions.productGradeOptions
								)
							}}
						</span>
						<span>–</span>
						<span class="flex-shrink truncate">
							{{ __("Harvest") }} {{ offer.product__harvest || __("n.a.") }}
						</span>
					</h3>
				</div>


				<!--	table			-->
				<div class="text-sm text-gray-500">

					<!--	Angebot	-->
					<div v-if="(offer.trade === 'SELL' && user)"
							 class="flex"
					>
						<span class="basis-1/12 min-w-28 shrink-0">{{ __("Location") }}:</span>
						<span class="flex flex-grow items-center">
							{{
								$cropOptions.getLocalizedLabel(
									offer.location__mode,
									$cropOptions.locationModeOptions
								)
							}}
							{{ offer.location__address__city }}

							<span  class="px-1" v-if="result.distance_road_km">
								({{ Number(result.distance_road_km).toFixed(0) }} km)
							</span>

							<span class="px-1" v-else-if="result.dispatched && !result.price_estimation_failed">
										<ui-loading-spinner :size="3" />
							</span>
						</span>
					</div>

					<div
						v-else-if="offer.trade === 'BUY' && user"
					>
						<div v-if="user.type === 'FARMER' && (result.dispatched || result.price_estimate)"
								 class="flex"
						>
							<span class="basis-1/12 min-w-14 shrink-0">{{ __("Location") }}:</span>
							<!-- Auf Price Estimation warten -->
							<span class="flex items-center" v-if="result.dispatched && !result.price_estimate_failed">
								<ui-loading-spinner :size="3" />
							</span>

							<!-- Price Estimation vorhanden -->
							<span
								v-else-if="result.price_estimate"
							>
								{{
									$cropOptions.getLocalizedLabel(
										"FCA",
										$cropOptions.locationModeOptions
									)
								}}
								{{ userLocation.city }}
							</span>

						</div>
						<!-- Franko, Abholung nicht möglich || Price Estimation failed || Frei Fuhre	-->
						<div v-else class="flex">

							<span class="basis-1/12 min-w-14 shrink-0">{{ __("Location") }}:</span>
							<span class="flex items-center">
								{{
									$cropOptions.getLocalizedLabel(
										offer.location__mode,
										$cropOptions.locationModeOptions
									)
								}}

								{{ offer.location__address__city }}

								<span  class="px-1" v-if="user.type !== 'FARMER' && result.distance_road_km">
									({{ Number(result.distance_road_km).toFixed(0) }} km)
								</span>

								<span class="px-1" v-else-if="
									user.type !== 'FARMER' &&
									result.dispatched &&
									!result.price_estimation_failed"
								>
											<ui-loading-spinner :size="3" />
								</span>

							</span>
						</div>
					</div>
				<!--	Nachfrage	-->
					<!--	Datum	-->
					<div class="flex">
						<span class="basis-1/12 shrink-0"
									:class="[offer.trade === 'SELL' ? 'min-w-28' : 'min-w-14']"
						>
							{{ __("Fulfilment Date") }}:
						</span>
						<span>
							{{ $cropOptions.dateToString(offer, locale, true) }}
						</span>
					</div>
					<!--	Menge	-->
					<div class="flex">
						<span class="basis-1/12 shrink-0 shrink-0 text-gray-900 font-semibold"
									:class="[offer.trade === 'SELL' ? 'min-w-28' : 'min-w-14']"
						>
							{{ __("Quantity") }}:
						</span>
						<span class="text-gray-900">
							<span class="text-gray-900 font-semibold">{{ offer.qty__mt }} t </span>
							<span>({{ __("Partial quantity possible") }})</span>
						</span>
					</div>
					<!--	Price	-->
					<div class="flex">
						<span
							class="basis-1/12 shrink-0 text-gray-900 font-semibold"
							:class="[offer.trade === 'SELL' ? 'min-w-28' : 'min-w-14', canSeePrice ? 'text-gray-900' : 'text-red-600']"
						>
							<span v-if="offer.trade == 'BUY'"> {{ __("Price") }}: </span>
							<span v-else> {{ __("Asking price") }}: </span>
						</span>
						<span class="flex items-center text-gray-900 font-semibold">

							<span v-if="canSeePrice">
								<span v-if="freightCostAdjusted() && result.price_estimate">
									{{
										result.price_estimate
											? $cropOptions.formatLocalizedNumber(
											result.price_estimate
										) + " €/t"
											: __("n.a.")
									}}
								</span>
								<span v-else-if="freightCostAdjusted() && result.dispatched && !result.price_estimate"
											class="flex items-center"
								>
									<ui-loading-spinner :size="3" />
								</span>
								<span v-else>
									{{
										offer.price__mt
											? $cropOptions.formatLocalizedNumber(offer.price__mt) +
											" €/t"
											: __("n.a.")
									}}
								</span>
							</span>

							<span v-else class="text-red-600">
								{{ __("Only for active users") }}
							</span>
						</span>
					</div>

				</div>
				<!--	table	-->

				<!-- CTA -->
				<div :class="canSeePrice ? 'flex xl:-mt-4' : 'flex'">
					<ui-button
						v-if="result.thread_id"
						type="primary"
						class="ml-auto text-sm"
						v-on:click="
							$inertia.visit($route('threads', { active_id: result.thread_id }))
						"
						>{{ __("Go to negotiation") }}</ui-button
					>
					<ui-button
						v-else
						type="primary"
						class="ml-auto text-sm"
						v-on:click="maybeBid()"
					>
						{{
							offer.trade == "BUY"
								? __("Go to Buy Offer")
								: __("Go to Sell Offer")
						}}
					</ui-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		result: {
			type: Object,
			required: true,
		},
		isActive: {
			type: Boolean,
			required: true,
		},
		user: {
			type: Object,
			required: false,
		},
		userLocation: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			offer: this.result.offer,
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {
		maybeBid() {
			if (this.acl.can_trade) {
				this.$bus.$emit(
					"toggle-iframe-modal",
					this.$route("bid.create", {
						targetType: this.offer.trade,
						targetId: this.offer.id,
					}),
					false,
					false
				);
			} else {
				this.$bus.$emit("toggle-permission-denied-modal");
			}
		},
		freightCostAdjusted() {
			let shouldBeAdjusted = false;

			if (
				this.user.type == "FARMER" &&
				this.offer.trade == "BUY" &&
				this.offer.location__mode == "DAP" &&
				this.offer.location__optional_transport
			) {
				shouldBeAdjusted = true;
			}

			return shouldBeAdjusted;
		},
	},
	computed: {
		canSeePrice() {
			return this.acl.see_price;
		},
	},
};
</script>

<style scoped>
/* table {
        border-spacing: .25rem 0;
    } */
/* table td {
        padding: 0;
    } */
</style>
